import { Rectangle } from "../primitives"
import { Format } from "./format"

/**
 * @memberOf Tee.Chart
 * @constructor
 * @public
 * @class Properties to display a rectangle panel around chart axes
 * @param {Tee.Chart} chart The parent chart this wall object belongs to.
 * @property {Format} format Defines visual properties to paint this wall.
 * @property {Boolean} [visible=true] Determines if this wall will be displayed or not.
 */
export function Wall(chart) {
	var f = (this.format = new Format(chart))
	f.fill = "#E6E6E6"
	f.stroke.fill = "black"
	f.z = 0
	f.depth = 0

	this.visible = true
	this.bounds = new Rectangle()
	this.size = 0

	this.draw = function () {
		f.cube(this.bounds)
		f.draw(chart.ctx, null, this.bounds)
	}
}
